export default function(expiry) {
  if (expiry > 0) {
    return "J-" + expiry;
  }

  return "J+" + Math.abs(expiry);
}
